export const downscaleProportionally = (
  srcWidth: number,
  srcHeight: number,
  maxWidth: number,
  maxHeight: number,
): { width: number; height: number } => {
  const ratio =
    srcWidth > maxWidth || srcHeight > maxHeight
      ? Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
      : 1;
  return {
    height: Math.round(srcHeight * ratio),
    width: Math.round(srcWidth * ratio),
  };
};
